import { Action, Store } from 'redux'
import { ActionsObservable, combineEpics } from 'redux-observable'

import Dependencies from '../Dependencies'
import Epic from '../Epic'
import State from '../../states'
import { Login } from '../../actions'

// Update credentials after loaded from storage
const updateCredentialsAfterLoaded = (
  action$: ActionsObservable<Action>,
  _store: Store<State>
) =>
  action$
    .filter(Login.loadCredentials.done.match)
    .filter(action => !!action.payload.result)
    .map(action => Login.updateCredentials(action.payload.result))

// Sign up guest if the loaded credentials is null
const signUpGuest = (
  action$: ActionsObservable<Action>,
  _store: Store<State>
) =>
  action$
    .filter(Login.loadCredentials.done.match)
    .filter(action => !action.payload.result)
    .map(() => Login.signUpGuest.started(undefined))

// Bind API key
const bindAPIKey = (
  action$: ActionsObservable<Action>,
  store: Store<State>,
  { logger, apiClient }: Dependencies
) =>
  action$
    .filter(Login.updateCredentials.match)
    // bind API key to the API client when it's loaded
    .do(() => {
      const { login } = store.getState()
      const apiKey = login.credentials ? login.credentials.sessionKey : null
      apiClient.apiKey = apiKey
      logger.info('Bound session key to APIClient')
    })
    .ignoreElements()

// Load user
const loadUser = (action$: ActionsObservable<Action>, _store: Store<State>) =>
  action$
    .filter(Login.updateCredentials.match)
    .filter(action => !!action.payload)
    .mapTo(Login.loadUser.started(undefined))

// Save credentials after sign up
const saveCredentialsAfterSignUpGuest = (
  action$: ActionsObservable<Action>,
  _store: Store<State>
) =>
  action$
    .filter(Login.signUpGuest.done.match)
    .map(action =>
      Login.saveCredentials.started(action.payload.result.credentials)
    )

// Save credentials after sign up
const updateCredentialsAfterSignUp = (
  action$: ActionsObservable<Action>,
  _store: Store<State>
) =>
  action$
    .filter(Login.signUpGuest.done.match)
    .map(action => Login.updateCredentials(action.payload.result.credentials))

// Save credentials after Login
const saveCredentialsAfterLogin = (
  action$: ActionsObservable<Action>,
  _store: Store<State>
) =>
  action$
    .filter(Login.login.done.match)
    .map(({ payload: { result: { user, sessionKeys } } }) =>
      Login.saveCredentials.started({
        userID: user.id,
        sessionKey: sessionKeys[0].secretKey
      })
    )

// Save credentials after login
const updateCredentialsAfterLogin = (
  action$: ActionsObservable<Action>,
  _store: Store<State>
) =>
  action$
    .filter(Login.login.done.match)
    .map(({ payload: { result: { user, sessionKeys } } }) =>
      Login.updateCredentials({
        userID: user.id,
        sessionKey: sessionKeys[0].secretKey
      })
    )

// Update bugsnag user info
const updateBugsnagUser = (
  action$: ActionsObservable<Action>,
  _store: Store<State>
) =>
  action$
    .filter(Login.updateCredentials.match)
    .map(({ payload }) => payload)
    .filter(credentials => !!credentials)
    .do(credentials => {
      Bugsnag.user = {
        id: credentials!.userID
      }
    })
    .ignoreElements()

export default combineEpics<Epic>(
  updateCredentialsAfterLoaded,
  bindAPIKey,
  signUpGuest,
  loadUser,
  saveCredentialsAfterSignUpGuest,
  updateCredentialsAfterSignUp,
  saveCredentialsAfterLogin,
  updateCredentialsAfterLogin,
  updateBugsnagUser
)



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/epics/shared/login.ts